import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable sonarjs/no-duplicate-string */
import { Box } from '@gemini/core';
import Redirection from '@/components/Redirection';
import Container from '@/components/structure/Container';
import { useOfferSelection, usePrefixI18n, } from '@/contexts/brandConfiguration/hooks';
import { useBreakpoint } from '@/hooks/useBreakpoints';
import { useTranslation } from '@/hooks/useTranslations';
import { TransactionTypeProvider } from '@/providers/TransactionTypeProvider';
import { OfferCards } from './OfferCards/OfferCards';
import { TransactionTypeButtonGroup } from './TransactionTypeButtonGroup';
export const OfferSelection = ({ pageConfiguration, landingType, }) => {
    const { t } = useTranslation();
    const prefix = usePrefixI18n();
    const locales = `${prefix}${pageConfiguration}.${landingType}`;
    const offer = useOfferSelection(pageConfiguration, landingType);
    const { isMobile } = useBreakpoint();
    return (_jsx(TransactionTypeProvider, { children: _jsxs(Container, { paddingVertical: {
                'breakpoint.base': 'spacing.32',
                'breakpoint.lg': 'spacing.80',
            }, children: [_jsx(Box, { textAlign: "center", typography: "typography.headline.32.bold", as: "h2", children: t(`${locales}.pricing.title`) }), _jsx(Box, { display: "flex", justifyContent: "center", marginVertical: "spacing.32", children: _jsx(TransactionTypeButtonGroup, { offers: offer.offers }) }), _jsx(OfferCards, { offer: offer }), _jsx(Box, { textAlign: "center", children: _jsx(Redirection, { pageConfiguration: pageConfiguration, landingType: landingType, hasLinkFullWidthResponsive: isMobile }) })] }) }));
};
